import React from "react";
import { Box, Grid, Typography, Chip } from "@mui/material";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const items = [
  {
    id: "tee-io",
    title: "Infinity Orb Tee",
    price: 28,
    img: require("../../@shared/assets/back-of-card.png"),
    tag: "New",
  },
  {
    id: "hoodie-royale",
    title: "Royale Hoodie",
    price: 55,
    img: require("../../@shared/assets/logo-icon-text-reg.png"),
    tag: "Hot",
  },
  {
    id: "mousepad-void",
    title: "Void City Mousepad",
    price: 24,
    img: require("../../@shared/assets/city-wide-landing.png"),
    tag: "Limited",
  },
];

export default function FeaturedMerchStrip() {
  return (
    <Box
      sx={{
        py: 6,
        px: { xs: 2, md: 6 },
        background: "linear-gradient(180deg,#200662 0%, #0e0326 100%)",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3, alignItems: "baseline" }}>
        <Typography variant="h4" sx={{ color: "#fff", fontWeight: 800 }}>
          Featured Merch
        </Typography>
        <Typography
          component={Link}
          to="/merch"
          sx={{ color: "#cfc6ff", textDecoration: "none", "&:hover": { color: "#fff" } }}
        >
          View All →
        </Typography>
      </Box>

      <Grid container spacing={2}>
        {items.map((item, i) => (
          <Grid item xs={12} sm={6} md={4} key={item.id}>
            <motion.div initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: i * .1 }}>
              <Box
                component={Link}
                to={`/merch?highlight=${item.id}`}
                sx={{
                  textDecoration: "none",
                  display: "block",
                  p: 2,
                  borderRadius: 3,
                  background: "rgba(255,255,255,.06)",
                  border: "1px solid rgba(255,255,255,.08)",
                  "&:hover": { background: "rgba(255,255,255,.1)" },
                }}
              >
                <Box sx={{ position: "relative", borderRadius: 2, overflow: "hidden", mb: 2 }}>
                  <img src={item.img} alt={item.title} style={{ width: "100%", height: 220, objectFit: "cover" }} />
                  <Chip
                    label={item.tag}
                    size="small"
                    sx={{
                      position: "absolute",
                      top: 10,
                      left: 10,
                      bgcolor: "secondary.main",
                      color: "#fff",
                      fontWeight: 700,
                    }}
                  />
                </Box>
                <Typography sx={{ color: "#fff", fontWeight: 700 }}>{item.title}</Typography>
                <Typography sx={{ color: "#cfc6ff" }}>${item.price}</Typography>
              </Box>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
